// extracted by mini-css-extract-plugin
export default {"table":"Table_table__1pbfL","header-cell":"Table_header-cell__akoUA","column-number":"Table_column-number__ku98o","date":"Table_date__03oc9"};